import { render, staticRenderFns } from "./ActasConcejoView.vue?vue&type=template&id=5d1514e0&"
import script from "./ActasConcejoView.vue?vue&type=script&lang=ts&"
export * from "./ActasConcejoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports